<template>
    <stats-card :title="title"
                :type="'gradient-'+type"
                class="mb-4 mb-xl-0">
        <template v-slot:header v-if="showHeader">
            <div class="row align-items-center">
                <div class="col">
                    <h6 class="text-uppercase text-muted ls-1 mb-1">Servicedesk</h6>
                </div>
                <div class="col-auto">
                    <div class="icon icon-shape"><i class="fad fa-tasks text-success" aria-hidden="true"></i></div>
                </div>
            </div>
            <hr class="mb-3 mt-1">
        </template>
        <div class="row mb-5">
            <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Monatliche</h6>
                <h5 class="h3 mb-0">Fallverteilung</h5>
            </div>
            <div class="col text-right">
                <el-select
                    class="select-primary pagination-select mr-3"
                    v-model="activeBar"
                    default-first-option>

                    <el-option
                        class="select-primary"
                        v-for="(yearData, index) in topdeskData"
                        :key="index"
                        :label="index"
                        :value="index"
                    >
                    </el-option>
                </el-select>
            </div>
        </div>
        <BarChart theme="light" ref="barChart"/>
        <span v-if="error.length > 0" class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        <template v-slot:footer>
        </template>
    </stats-card>
</template>
<script>
import {ref, watch, onMounted} from 'vue';
import {
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";
import Card from '@/components/Cards/Card';
import UserService from '@/services/user.service';
import BarChart from '@/components/Charts/BarChart'
import moment from 'moment';
import 'moment/locale/de';

export default {
    name: 'IncidentChartMonth',
    components: {
        Card,
        BarChart,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    props: {
        type: {
            type: String,
            default: "orange"
        },
        title: {
            type: String,
            default: "Kategorien"
        },
        showHeader: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const error = ref('');

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (request.response && request.response.data) ||
                    request.message ||
                    request.toString();
            }
        }

        const activeBar = ref('');
        const topdeskData = ref({});

        const incidentBarChart = ref({
            chartData: {
                labels: [],
                datasets: []
            }
        });

        function getChartData() {
            UserService.getIncidents(0, 10000).then(
                response => {
                    response.data.data.forEach(incident => {
                        const labelOption = {
                            show: true,
                            position: 'insideBottom',
                            distance: 15,
                            align: 'left',
                            verticalAlign: 'middle',
                            rotate: '90',
                            formatter: '{c}  {name|{a}}',
                            fontSize: 16,
                            rich: {
                                name: {}
                            }
                        };
                        const barChartData = {
                            datasets: [
                                {
                                    name: 'Fälle',
                                    type: 'bar',
                                    barGap: 0,
                                    label: labelOption,
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                                },
                            ],
                            labels: ['Fälle'],
                            xAxis: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                        };
                        if (!(moment(incident.creationDate).format('YYYY') in topdeskData.value)) {
                            topdeskData.value[moment(incident.creationDate).format('YYYY')] = {
                                barChartData: barChartData
                            };
                        }
                        topdeskData.value[moment(incident.creationDate).format('YYYY')].barChartData.datasets[0].data[topdeskData.value[moment(incident.creationDate).format('YYYY')].barChartData.xAxis.indexOf(moment(incident.creationDate).format('MMMM'))]++;
                    });
                    activeBar.value = Object.keys(topdeskData.value)[Object.keys(topdeskData.value).length - 1];
                },
                error => {
                    getError(error);
                }
            );
        }

        const barChart = ref({});

        watch(activeBar, () => {
            if (topdeskData.value && Object.keys(topdeskData.value).length > 0) {
                incidentBarChart.value.chartData = JSON.parse(JSON.stringify(topdeskData.value[activeBar.value].barChartData));
                barChart.value.option.title.text = activeBar.value;
                barChart.value.option.legend.data = incidentBarChart.value.chartData.labels;
                barChart.value.option.xAxis[0].data = incidentBarChart.value.chartData.xAxis;
                barChart.value.option.series = incidentBarChart.value.chartData.datasets;
            }
        });

        onMounted(() => {
            getChartData();
        });

        return {
            error,
            barChart,
            activeBar,
            topdeskData,
            getChartData,
        }
    }
}
</script>

<style lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.chartCard {
    margin-bottom: 0;
    box-shadow: inherit !important;
}
</style>
